import { ChangeDetectionStrategy, Component, HostListener, inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CapturumButtonModule } from '@capturum/ui/button';
import { CapturumPasswordModule } from '@capturum/ui/password';
import { DialogLayoutComponent } from '@core/components/dialog-layout/dialog-layout.component';
import { OtpDialogConfig, OtpRequest } from '@core/interfaces/otp.interface';
import { TranslateModule } from '@ngx-translate/core';
import { NeqtoAuthService } from '@shared/services/neqto-auth.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-current-password-dialog',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    DialogLayoutComponent,
    CapturumButtonModule,
    CapturumPasswordModule,
  ],
  templateUrl: './current-password-dialog.component.html',
  styleUrl: './current-password-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CurrentPasswordDialogComponent {
  form: FormGroup<{ password: FormControl<string> }>;

  readonly #dialogRef = inject(DynamicDialogRef);
  readonly #config = inject<DynamicDialogConfig<OtpDialogConfig>>(DynamicDialogConfig<OtpDialogConfig>);
  readonly #formBuilder = inject(FormBuilder);
  readonly #authService = inject(NeqtoAuthService);

  constructor() {
    this.form = this.#formBuilder.group({
      password: this.#formBuilder.control('', { nonNullable: true, validators: [Validators.required] }),
    });
  }

  @HostListener('keydown.enter')
  submit(): void {
    this.form.markAllAsTouched();

    if (this.form.valid) {
      const purpose = this.#config.data?.purpose;
      const payload = this.form.value as OtpRequest;

      this.#authService.loginOtp(purpose, payload).subscribe(({ otp }) => {
        this.close(otp);
      });
    }
  }

  close(data: string = null): void {
    this.#dialogRef.close(data);
  }
}
